import PatientsScreen from './PatientsScreen';
export default PatientsScreen;
